import { ENVIRONMENT } from "@/config/config";

class Logger {
  constructor(mode) {
    if (mode === "PRODUCTION") {
      for (let m in console) {
        if (typeof console[m] == "function") {
          this[m] = console[m].bind(console);
        }
      }
      this.error = console.error.bind(console);
    } else {
      for (let m in console) {
        if (typeof console[m] == "function") {
          this[m] = console[m].bind(console);
        }
      }
    }
  }
}

const logger = new Logger(ENVIRONMENT);
export default logger;
